// @flow

import type {
  MarkdocNodeRegistration,
  MarkdocTagRegistration,
} from 'docs/markdoc';

import {Href} from 'docs/markdoc/attribute-types';

export const Link: MarkdocNodeRegistration = {
  node: 'link',
  component: 'Link',
  children: ['strong', 'em', 'code', 'text', 'tag'],
  attributes: {
    href: {type: Href, required: true},
    title: {type: String, localizable: true},
  },
};

export const LinkTag: MarkdocTagRegistration = {
  tag: 'link',
  component: 'Link',
  description: 'Render a link',
  children: ['strong', 'em', 'code', 'text', 'tag'],
  attributes: {
    href: {
      type: Href,
      description: 'The url for the link',
      required: true,
      localizable: false,
    },
    title: {
      type: String,
      description: 'The value for the html title attribute',
      localizable: true,
    },
    id: {
      type: String,
      description: 'The value for the html id attribute',
      localizable: false,
    },
  },
};
